export const AGENCY_LEVELS = {
  "non-ua": "Non-UA",
  level_1: "Gold",
  level_2: "Platinum",
  level_3: "Diamond",
};
